import { atom } from "jotai"

export type TGenealogyResponse = {
    favorites: []
    items: TGenealogyItem[]
    limit: number | string
    next: string | number | null
    prev: string | number | null
}

export type TGenealogyItem = {
    customer: TGenealogyCustomer
    treeDepth: number
}

export type TGenealogyCustomer = {
    achievementHistory: {
        items: TAchievementHistoryItem[]
    }
    cumulativeMetricsProfile: {
        highestRankShort: string
        highestRankSortId: string
    }
    email: string
    enroller: Record<string, number>
    homePhone: string
    humanName: {
        firstName: string
        fullName: string
        'fullName@vi': string
        lastName: string
    }
    id: {
        unicity: string
    }
    joinDate: string
    mainAddress: {
        address1: string
        address2: string
        city: string
        state: string
        zip: string
        country: string
    }
    metricsProfile: {
        active_legs: number
        apv: number
        cpv: number
        cqv: number
        ov: number
        pv: number
        rankShort: string
        tv: number
        
    }
    metricsProfileHistory: Record<string, number>
    mobilePhone: string
    rights: string[]
    sponsor: Record<string, number>
    sponsoredCustomers: {
        href: string
    }
    status: string
    type: string
    unicity: string
    workPhone: string
}

export type TAchievementHistoryItem = {
    value: [
        {
            achievement: {
                bonusName: string
            }
            qualified: boolean
        }
    ]
}

export const genealogyAtom = atom<TGenealogyResponse | null>(null)
export const genealogyIsLoadingAtom = atom(false)
export const genealogyErrorAtom = atom('')